import { z } from 'zod';

const PathsSchema = z.object({
  auth: z.object({
    signIn: z.string().min(1),
    signUp: z.string().min(1),
    verifyMfa: z.string().min(1),
    callback: z.string().min(1),
    passwordReset: z.string().min(1),
    passwordUpdate: z.string().min(1),
  }),
  app: z.object({
    home: z.string().min(1),
    personalAccountprojects: z.string().min(1),
    personalAccountroadmap: z.string().min(1),
    personalAccountSettings: z.string().min(1),
    personalAccountBilling: z.string().min(1),
    personalAccountBillingReturn: z.string().min(1),
    accountHome: z.string().min(1),
    accountSettings: z.string().min(1),
    accountMembers: z.string().min(1),
    accountBilling: z.string().min(1),
    accountKanban: z.string().min(1),
    accountConversations: z.string().min(1),
    accountMilestones: z.string().min(1),
    accountViews: z.string().min(1),
    accountVR: z.string().min(1),
    accountWorkflows: z.string().min(1),
    accountKanbanBoard: z.string().min(1),
    accountKanbanMobile: z.string().min(1),
    accountKanbanBoardSettings: z.string().min(1),
    accountFiles: z.string().min(1),
    accountBot: z.string().min(1),
    accountBillingReturn: z.string().min(1),
    joinTeam: z.string().min(1),
    bimViewer: z.string().min(1),
    accountSupport: z.string().min(1),
    accountSiteSafety: z.string().min(1),
    accountLiveStreams: z.string().min(1),
    accountMediaHub: z.string().min(1),
    account360Video: z.string().min(1),
    accountRoomBuilder: z.string().min(1),
    accountProgressMonitoring: z.string().min(1),
    accountPlanning: z.string().min(1),
  }),
});

const pathsConfig = PathsSchema.parse({
  auth: {
    signIn: '/auth/sign-in',
    signUp: '/auth/sign-up',
    verifyMfa: '/auth/verify',
    callback: '/auth/callback',
    passwordReset: '/auth/password-reset',
    passwordUpdate: '/update-password',
  },
  app: {
    home: '/home/projects',
    personalAccountprojects: '/home/projects',
    personalAccountroadmap: '/home/roadmap',
    personalAccountSettings: '/home/settings',
    personalAccountBilling: '/home/billing',
    personalAccountBillingReturn: '/home/billing/return',
    accountHome: '/home/[account]',
    accountSettings: `/home/[account]/settings`,
    accountBilling: `/home/[account]/billing`,
    accountMembers: `/home/[account]/members`,
    accountBillingReturn: `/home/[account]/billing/return`,
    accountKanban: '/home/[account]/boards',
    accountConversations: '/home/[account]/conversations',
    accountMilestones: '/home/[account]/boards/milestones',
    accountKanbanBoard: '/home/[account]/boards/[board]',
    accountKanbanMobile: '/home/[account]/tasks-mobile',
    accountKanbanBoardSettings: '/home/[account]/boards/[board]/settings',
    accountViews: '/home/[account]/views',
    accountVR: '/home/[account]/vr',
    accountWorkflows: '/home/[account]/workflows',
    accountFiles: `/home/[account]/files`,
    accountBot: `/home/[account]/chatbot`,
    joinTeam: '/join',
    bimViewer: '/home/viewer',
    accountSupport: '/home/[account]/tickets',
    accountSiteSafety: '/home/[account]/site-safety',
    accountLiveStreams: '/home/[account]/livestreams',
    accountMediaHub: '/home/[account]/media-hub',
    account360Video: '/home/[account]/360-video',
    accountRoomBuilder: '/home/[account]/room-builder',
    accountProgressMonitoring: '/home/[account]/progress-monitoring',
    accountPlanning: '/home/[account]/planning',
  },
} satisfies z.infer<typeof PathsSchema>);

export default pathsConfig;
